// Centralized content for the landing page

export const IMAGES = {
    // SIRCS brand logo (transparent-friendly, applied with mix-blend-mode: screen)
    sircsLogo:
        "https://customer-assets.emergentagent.com/job_sircs-mentality/artifacts/igwulncy_Photoroom_20260621_143416.png",
    // HERO: brazos cruzados premium full-body (foto estrella)
    hero: "https://customer-assets.emergentagent.com/job_sircs-mentality/artifacts/yqutxwzt_73EDA18D-4D5D-4574-8D48-6B12B9E82ED2.png",
    // ABOUT: sentado en taburete, mirada 3/4 directa
    about: "https://customer-assets.emergentagent.com/job_sircs-mentality/artifacts/7dsvyhh6_EC2BD580-52B8-4FF2-828B-DF04680053A8.png",
    // PRICING: brazos cruzados de pie (autoridad/decisión)
    pricing:
        "https://customer-assets.emergentagent.com/job_sircs-mentality/artifacts/qs77e8n7_093EFD2A-7153-4619-BC41-71EC42F5F297.png",
    // FINAL CTA: sentado, manos entrelazadas (cierre, presencia contemplativa)
    finalCta:
        "https://customer-assets.emergentagent.com/job_sircs-mentality/artifacts/ooq29n9c_199BF33D-CBFD-4940-8CCA-E9FB083D13BF.png",
};

// Sunday, July 19, 2026 — 20:00 Madrid
export const START_DATE = new Date("2026-07-19T20:00:00+02:00");

// Hotmart checkout URLs
export const HOTMART = {
    grupal: {
        url: "https://pay.hotmart.com/E106255631Q?off=pg9uuo5x",
        price: 497,
        currency: "EUR",
        installments: 3,
        contentId: "desactiva-patron-grupal",
        contentName: "Desactiva el Patrón — General",
    },
    premium: {
        url: "https://pay.hotmart.com/E106255631Q?off=ombypcgy",
        price: 997,
        currency: "EUR",
        installments: 4,
        contentId: "desactiva-patron-premium",
        contentName: "Desactiva el Patrón — Premium",
    },
};

// WhatsApp for information / consultation
export const WHATSAPP = {
    number: "34605045728", // sin '+', formato wa.me
    messages: {
        grupal:
            "Hola Santi, vengo desde la landing 'Desactiva el Patrón'. Me interesa la opción General (497 €) y quiero pedirte información antes de reservar.",
        premium:
            "Hola Santi, vengo desde la landing 'Desactiva el Patrón'. Me interesa la Mentoría Premium (997 €) y quiero pedirte información antes de reservar.",
        general:
            "Hola Santi, vengo desde la landing 'Desactiva el Patrón' y quiero pedirte información sobre la mentoría antes de decidir.",
    },
};

// WhatsApp broadcast channel — free updates about future editions
export const WHATSAPP_CHANNEL = {
    url: "https://whatsapp.com/channel/0029Vb7YjesIiRp1ZrnRuP1M",
    label: "Únete al canal de WhatsApp",
    contentName: "WhatsApp Channel — Desactiva el Patrón",
};

// ============================================================
// GEO-BASED PRICING ZONES
// Each zone changes ONLY price string, currency and Hotmart URL.
// ============================================================
export const PRICE_ZONES = {
    z1: {
        id: "z1",
        currency: "EUR",
        label: "España",
        general: {
            price: "497 €",
            url: "https://pay.hotmart.com/E106255631Q?off=pg9uuo5x",
            value: 497,
            currency: "EUR",
        },
        premium: {
            price: "997 €",
            url: "https://pay.hotmart.com/E106255631Q?off=ombypcgy",
            value: 997,
            currency: "EUR",
        },
    },
    z2: {
        id: "z2",
        currency: "USD",
        label: "Latinoamérica",
        general: {
            price: "289 USD",
            url: "https://pay.hotmart.com/E106255631Q?off=5pfkw1nj",
            value: 289,
            currency: "USD",
        },
        premium: {
            price: "579 USD",
            url: "https://pay.hotmart.com/E106255631Q?off=hg8rwubj",
            value: 579,
            currency: "USD",
        },
    },
    z3: {
        id: "z3",
        currency: "ARS",
        label: "Argentina",
        general: {
            price: "289.000 ARS",
            url: "https://pay.hotmart.com/E106255631Q?off=6g2yoqk5",
            value: 289000,
            currency: "ARS",
        },
        premium: {
            price: "579.000 ARS",
            url: "https://pay.hotmart.com/E106255631Q?off=e3hpyghh",
            value: 579000,
            currency: "ARS",
        },
    },
};

// URL param ?z=... → zone id
export const Z_PARAM_MAP = { e1: "z1", l2: "z2", a3: "z3" };

// Country ISO2 code → { zone, name (Spanish) }
export const COUNTRY_ZONE = {
    // ZONA 2 — USD
    MX: { zone: "z2", name: "México" },
    CO: { zone: "z2", name: "Colombia" },
    PE: { zone: "z2", name: "Perú" },
    CR: { zone: "z2", name: "Costa Rica" },
    VE: { zone: "z2", name: "Venezuela" },
    EC: { zone: "z2", name: "Ecuador" },
    BO: { zone: "z2", name: "Bolivia" },
    PY: { zone: "z2", name: "Paraguay" },
    GT: { zone: "z2", name: "Guatemala" },
    HN: { zone: "z2", name: "Honduras" },
    SV: { zone: "z2", name: "El Salvador" },
    NI: { zone: "z2", name: "Nicaragua" },
    DO: { zone: "z2", name: "República Dominicana" },
    CU: { zone: "z2", name: "Cuba" },
    BR: { zone: "z2", name: "Brasil" },
    // ZONA 3 — ARS
    AR: { zone: "z3", name: "Argentina" },
    // ZONA 1 — EUR (explicit country names; any other country also falls to z1)
    ES: { zone: "z1", name: "España" },
    US: { zone: "z1", name: "Estados Unidos" },
    PR: { zone: "z1", name: "Puerto Rico" },
    PA: { zone: "z1", name: "Panamá" },
    CL: { zone: "z1", name: "Chile" },
    UY: { zone: "z1", name: "Uruguay" },
};


export const IDENTIFICATION = [
    "Empiezas cambios con fuerza y terminas abandonándote otra vez.",
    "Sabes lo que tienes que hacer, pero no consigues sostenerlo.",
    "Piensas demasiado y actúas poco.",
    "Te bloqueas justo cuando algo importante empieza a moverse.",
    "Te cuesta tomar decisiones por miedo a equivocarte.",
    "Buscas aprobación y acabas traicionándote.",
    "Te cuesta poner límites sin culpa.",
    "Te saboteas cuando podrías avanzar.",
    "Has consumido desarrollo personal, pero sigues sintiendo que algo no cambia de verdad.",
    "Sientes que tienes potencial, pero no logras vivir desde él.",
    "Estás cansado de volver siempre al mismo patrón.",
];

export const PROMISE = [
    "Reconocer tu piloto automático.",
    "Identificar el patrón que más se repite en tu vida.",
    "Detectar las creencias que sostienen tu comportamiento.",
    "Comprender qué emoción estás evitando.",
    "Dejar de identificarte con el personaje que construiste para sobrevivir.",
    "Tomar decisiones desde una nueva identidad.",
    "Sostener cambios reales cuando el viejo patrón vuelva.",
    "Crear un plan SIRCS de 90 días para no volver al mismo lugar.",
];

export const PILLARS = [
    {
        title: "El Zoom despierta",
        desc: "Cada semana una sesión grupal en directo. Explicación, ejercicios, dinámicas e intervenciones en directo. Aquí no vienes a escuchar, vienes a verte.",
    },
    {
        title: "La hipnomeditación integra",
        desc: "Audio semanal de hipnomeditación para integrar emocionalmente el trabajo, conectar con nuevos significados e instalar una nueva dirección interna.",
    },
    {
        title: "El grupo sostiene",
        desc: "Grupo privado de WhatsApp durante 8 semanas. Avances, bloqueos, decisiones y victorias. No es para desahogarse sin rumbo, es para sostener la nueva identidad.",
    },
    {
        title: "Los GPTs SIRCS profundizan",
        desc: "Cada semana un GPT SIRCS guiado que te hará preguntas profundas, te pedirá ejemplos concretos y te ayudará a ordenar lo que no habías sabido expresar.",
    },
];

export const WEEKS = [
    {
        n: "Semana 01",
        phase: "Sensibilización",
        title: "Despierta del piloto automático",
        desc: "Observa dónde estás viviendo desde patrones automáticos, qué situaciones se repiten y qué decisiones llevas tiempo postergando.",
        outcome: "Mapa personal del piloto automático",
        gpt: "Sensibilización",
        meditation: "El observador interior",
    },
    {
        n: "Semana 02",
        phase: "Identificación",
        title: "Descubre las creencias que sostienen tu patrón",
        desc: "Identifica las frases internas, creencias y significados que están condicionando tus decisiones.",
        outcome: "Mapa de creencias limitantes",
        gpt: "Identificación de creencias",
        meditation: "Reencuadre de creencias limitantes",
    },
    {
        n: "Semana 03",
        phase: "Identificación emocional",
        title: "Encuentra el patrón emocional raíz",
        desc: "Descubre qué emoción estás evitando cuando te saboteas, procrastinas, controlas, complaces o te bloqueas.",
        outcome: "Mapa del patrón emocional raíz",
        gpt: "Patrón emocional raíz",
        meditation: "Encuentro con el patrón emocional raíz",
    },
    {
        n: "Semana 04",
        phase: "Reprogramación",
        title: "Rompe con el personaje automático",
        desc: "Comprende que no eres tu patrón. Ese personaje fue una estrategia de supervivencia, no tu identidad real.",
        outcome: "Mapa del personaje automático",
        gpt: "Personaje automático",
        meditation: "Separación del personaje automático",
    },
    {
        n: "Semana 05",
        phase: "Consolidación de identidad",
        title: "Construye tu nueva identidad",
        desc: "Define quién estás eligiendo ser, qué límites necesitas poner y qué decisiones tomaría tu nueva versión.",
        outcome: "Declaración de nueva identidad",
        gpt: "Nueva identidad",
        meditation: "Instalación de nueva identidad",
    },
    {
        n: "Semana 06",
        phase: "Consolidación en acción",
        title: "Pasa a la acción consciente",
        desc: "Convierte la transformación interna en acciones reales, simples y sostenibles.",
        outcome: "Plan semanal de acción consciente",
        gpt: "Acción consciente",
        meditation: "Motivación profunda para sostener acción",
    },
    {
        n: "Semana 07",
        phase: "Sostenimiento",
        title: "Aprende a no volver al viejo patrón",
        desc: "Crea un protocolo para responder cuando aparezcan la recaída, la resistencia, el miedo o la duda.",
        outcome: "Protocolo personal de recaídas",
        gpt: "Protocolo de recaídas",
        meditation: "Elegir distinto en el momento crítico",
    },
    {
        n: "Semana 08",
        phase: "Dirección y sostenimiento",
        title: "Diseña tus próximos 90 días",
        desc: "Cierra el proceso con claridad, visión y un plan de sostenimiento para seguir actuando desde tu nueva identidad.",
        outcome: "Plan SIRCS de 90 días",
        gpt: "Plan 90 días",
        meditation: "Dirige tu vida",
    },
];

export const INCLUDES = [
    "8 sesiones grupales en directo por Zoom",
    "Grupo privado de WhatsApp",
    "Ejercicios semanales de integración",
    "Dinámicas prácticas durante las sesiones",
    "Intervenciones en directo con Santi",
    "8 audios de hipnomeditación e integración semanal",
    "GPTs SIRCS semanales (incluidos en Premium · +74 € en General)",
    "Mapas de conciencia",
    "Plan semanal de acción consciente",
    "Protocolo personal de recaídas",
    "Plan SIRCS de 90 días",
    "Grabación de las sesiones en directo",
    "Invitación especial a continuar en Skool",
];

export const TESTIMONIALS = [
    "Me di cuenta de que llevaba años viviendo para los demás y olvidándome de mí.",
    "Entendí que mi problema no era pensar demasiado, sino intentar controlarlo todo para no sentir miedo.",
    "Por primera vez entendí que no era débil. Estaba funcionando desde un patrón aprendido.",
    "La hipnomeditación me ayudó a sentir algo que solo hablando no había conseguido integrar.",
    "No fue motivación. Fue verme de verdad.",
];

export const COMPARISON_ROWS = [
    ["8 sesiones en directo por Zoom", true, true],
    ["Grupo privado de WhatsApp", true, true],
    ["GPTs SIRCS", "+74 € aparte", "Incluido sin coste extra"],
    ["Hipnomeditaciones semanales", true, true],
    ["Ejercicios de integración", true, true],
    ["Grabaciones de las sesiones", true, true],
    ["Plan SIRCS 90 días", true, true],
    ["Prioridad en intervenciones", false, true],
    ["2 sesiones privadas 1:1", false, true],
    ["Revisión personalizada del proceso", false, true],
    ["Revisión de resultados de GPTs", false, true],
    ["Ajuste individual de bloqueos y acciones", false, true],
    ["Adaptación de hipnomeditaciones", false, true],
    ["Revisión del Plan SIRCS 90 días", false, true],
];

export const NOT_FOR = [
    "Buscas soluciones mágicas.",
    "Quieres consumir contenido sin aplicar nada.",
    "Quieres que alguien haga el trabajo por ti.",
    "No estás dispuesto a mirarte con honestidad.",
    "Quieres seguir justificando el mismo patrón sin responsabilizarte de cambiarlo.",
];

export const FOR_YOU = [
    "Estás cansado de volver siempre al mismo lugar.",
    "Sabes que algo tiene que cambiar.",
    "Estás dispuesto a observarte con honestidad.",
    "Quieres dejar de traicionarte cada vez que intentas avanzar.",
    "Sientes que ha llegado el momento de empezar a dirigirte de verdad.",
];

export const FAQ = [
    {
        q: "¿Y si me da miedo la hipnosis?",
        a: "Es normal: casi todo lo que se ve de hipnosis es espectáculo de televisión. Aquí no hay nada de eso. Las hipnomeditaciones son audios guiados con mi voz que escuchas cuando quieras, en la cama o en el sofá, con los ojos cerrados. Estás consciente en todo momento y puedes pararlo cuando quieras.",
    },
    {
        q: "¿Necesito experiencia previa?",
        a: "No. Solo ganas de mirarte con honestidad y 8 semanas de compromiso. El resto lo hacemos juntos.",
    },
    {
        q: "¿Esto es terapia?",
        a: "No. Es un proceso de mentoría, desarrollo personal, reprogramación mental, conciencia emocional y acción consciente. No sustituye una terapia psicológica ni un tratamiento clínico.",
    },
    {
        q: "¿Qué pasa si no puedo asistir en directo?",
        a: "Las sesiones serán en directo por Zoom y quedarán grabadas para que puedas repasarlas o recuperarlas si un día no puedes asistir. Aun así, la recomendación es participar en directo siempre que sea posible.",
    },
    {
        q: "¿Tengo que hablar delante del grupo?",
        a: "No estarás obligado a compartir nada que no quieras. El grupo será un espacio seguro, respetuoso y guiado. Cuanto más te impliques, más profundo será el proceso.",
    },
    {
        q: "¿Qué pasa si ya he probado muchas cosas?",
        a: "Precisamente por eso existe Desactiva el Patrón. Muchas personas no necesitan más información: necesitan entender qué patrón les hace volver atrás y aprender a responder desde una nueva identidad.",
    },
    {
        q: "¿Qué son los GPTs SIRCS?",
        a: "Son asistentes interactivos semanales diseñados para ayudarte a profundizar en cada fase del proceso. No son un ChatGPT libre: cada GPT está enfocado en una semana concreta. En la opción General el acceso a los GPTs SIRCS es un extra opcional de 74 € que se gestiona aparte tras la inscripción; en la opción Premium van incluidos sin coste adicional.",
    },
    {
        q: "¿Qué diferencia hay entre la General y la Premium?",
        a: "La General incluye el proceso completo. En la General, el acceso a los GPTs SIRCS es un extra de 74 € que se gestiona aparte tras la inscripción. La Premium incluye todo lo de la General —con los GPTs SIRCS ya incluidos sin coste adicional— y además 2 sesiones privadas conmigo, revisión personalizada de tu proceso, prioridad en intervenciones y adaptación de hipnomeditaciones a tu caso cuando sea necesario.",
    },
];
